export const body = {
    title: {
        en: 'Tasks',
        ru: 'Задания'
    }
}
